import { createWebHistory, createRouter } from "vue-router";
import mushroom from "cem-primary-api";

import routes from "./routes";
import appConfig from "../../app.config";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach(async function (to, from, next) {
  
  if (from.name != to.name) {
    if (to.meta.page && to.meta.page == "admin") {
      // lưu đường dẫn link web hiện tại vào stograte để sau login lại
      next();
      

      setTimeout(() => {
        localStorage.setItem("urlOld", window.location.href);
      }, 200);

      setTimeout(async () => {
        try {
          const userResponse = await mushroom.$auth.meAsync();
          if(userResponse) localStorage.setItem("userInfo", JSON.stringify(userResponse));
        } catch (error) {
          window.localStorage.clear();
          next("/login");
        }
      }, 200);

      clearTimeout(window.checkStatusDownloadProbe); // xoá check download dashboard
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
    } else {
      next("/error");
    }
  } else if (from.name && to.name && from.name == to.name) {
    next();
  } else {
    if (!to.name) {
      next("/error");
    } else next("/session-time-out");
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + " | " + appConfig.title;
  next();
});

export default router;
